<template>
    <div>
        <hasError :e="error" />
        <template v-if="isDisabled">
            <textInput
                :label="label ? label : ''"
                type="TEXT"
                :iniDisabled="true"
                :value="theValue ? `${theValue.id} - ${theValue.name}` : null">
            </textInput>
        </template>
        <template v-else>
            <textInput type="CUSTOM" :label="label ? label : ''" :v="v">
                <template slot="help" v-if="description">{{ description }}</template>
                <template slot="custom">
                    <b-dropdown aria-role="menu" class="dropdown-listed" :mobile-modal="false">
                        <a
                            class="button is-cancel is-outlined"
                            slot="trigger"
                            style="text-transform: none; font-weight: normal">
                            <template v-if="isLoading">
                                <loader text=" " />
                                <span class="mr5-xs"></span>
                            </template>
                            <span v-if="theValue">
                                <span class="tag is-primary mr5-xs" style="margin-left: -5px"> {{ theValue.id }} </span>
                                {{ theValue.name }}
                            </span>
                            <template v-else>
                                <span>
                                    {{ $t('choose') }}
                                </span>
                            </template>
                            <span class="icon">
                                <font-awesome-icon :icon="['fas', 'angle-down']" />
                            </span>
                        </a>
                        <b-dropdown-item aria-role="menu-item" custom>
                            <textInput
                                type="SEARCH"
                                v-model="searchTerm"
                                @input="
                                    () => {
                                        fetchData();
                                    }
                                "
                                ref="search" />
                        </b-dropdown-item>

                        <b-dropdown-item aria-role="menu-item" v-if="isLoading" class="is-info">
                            <loader :text="$t('searching')" />
                        </b-dropdown-item>
                        <b-dropdown-item
                            aria-role="menu-item"
                            v-if="data && data.length == 0 && !isLoading"
                            class="is-info"
                            >{{ $t('nothingFound') }}</b-dropdown-item
                        >

                        <b-dropdown-item aria-role="menu-item" :key="index" v-for="(item, index) in data" has-link>
                            <a href="javascript:void(0)" @click.prevent="doUpdate(item.id)">
                                <span class="tag"> {{ item.id }} </span> {{ item.name }}
                            </a>
                        </b-dropdown-item>
                        <template v-if="!showDefaults">
                            <pagination
                                :count="count"
                                v-model="pagination"
                                :hidePerPage="true"
                                :iniPerPage="10"></pagination>
                        </template>
                        <template v-if="value">
                            <hr class="dropdown-divider" aria-role="menuitem" />
                            <b-dropdown-item aria-role="menu-item" @click="doUpdate">
                                <span class="icon">
                                    <font-awesome-icon :icon="['fas', 'times']" />
                                </span>
                                <span> {{ $t('clear') }} </span>
                            </b-dropdown-item>
                        </template>
                    </b-dropdown>
                </template>
            </textInput>
        </template>
    </div>
</template>
<script>
import { getCurrencies, getCurrency } from './../services/projects';

import paginationMixin from './../mixins/pagination.js';

export default {
    name: 'CurrencyView',
    props: {
        isDisabled: {
            type: Boolean,
        },
        label: {
            type: String,
        },
        value: {
            type: String,
        },
        v: [Object, Function],
    },
    mixins: [paginationMixin],
    data() {
        return {
            theValue: null,
            currencies: [],
            isLoading: false,
            error: null,

            searchTerm: null,
            isSearching: false,
            count: null,

            description: null,
            defaultCurrencies: [
                {
                    id: 'EUR',
                    isoNumber: 978,
                    numberOfDecimals: 2,
                    name: 'Euro',
                },

                {
                    id: 'USD',
                    isoNumber: 840,
                    numberOfDecimals: 2,
                    name: 'United States dollar',
                },
                {
                    id: 'JPY',
                    isoNumber: 392,
                    numberOfDecimals: 0,
                    name: 'Japanese yen',
                },

                {
                    id: 'GBP',
                    isoNumber: 826,
                    numberOfDecimals: 2,
                    name: 'Pound sterling',
                },
            ],
        };
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    computed: {
        showDefaults() {
            return this.searchTerm ? false : true;
        },
        data() {
            if (this.showDefaults) {
                return this.defaultCurrencies;
            } else {
                return this.currencies;
            }
        },
    },
    created() {
        this.handleValue();
        this.fetchData();
    },
    methods: {
        paginateChange(newPagination) {
            this.fetchData(newPagination);
        },
        fetchData(pagination = this.pagination) {
            this.isLoading = true;
            let payload = {
                page: pagination.currentPage,
                itemsPerPage: pagination.perPage,
                searchTerm: this.searchTerm ? this.searchTerm : ' ',
                sortField: 'name',
                sortOrder: 'asc',
            };
            getCurrencies(payload)
                .then((response) => {
                    this.currencies = response.data;
                    this.count = response.count;
                })
                .catch((e) => {
                    this.error = e;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async handleValue() {
            if (this.value) {
                this.theValue = await getCurrency({ id: this.value })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((e) => {});
            } else {
                this.theValue = null;
            }
        },
        doUpdate(newValue) {
            this.$emit('input', newValue);
        },
    },
    i18n: {
        messages: {
            en: {
                nothingFound: 'Nothing found',
                choose: 'Choose...',
                clear: 'Clear',
            },
            fr: {
                nothingFound: 'Rien trouvé',
                choose: 'Choisissez...',
                clear: 'Effacer',
            },
            nl: {
                nothingFound: 'Niets gevonden',
                choose: 'Kies...',
                clear: 'Wissen',
            },
        },
    },
};
</script>
